
export const links = [
    {
        name: "Home",
        path: '/',
        target: ''
    },
    {
        name: "Portfolio",
        path: '/portfolio',
        target: ''
    },
    {
        name: "Contact",
        path: '/contact',
        target: ''
    },
    {
        name: "Marketplace",
        path: 'https://www.minecraft.net/pl-pl/marketplace/creator?name=aliquam+studios',
        target: '_blank'
    },
    {
        name: "Aliquam Creative",
        path: 'https://www.planetminecraft.com/server/aliquam/',
        target: '_blank'
    }
]